import { gql } from '@apollo/client';

export const SEARCH_STYLE = gql`
    query LocationsQuery(
        $__typename: String!
        $index: String!
        $query: String!
        $filters: String!
        $hit: Number!
        $page: Number!
        $facets: [String]!
        $typoTolerance: Boolean
        $advancedSyntax: Boolean
    ) {
        locationsInRadius
            @algolia(
                __typename: $__typename
                index: $index
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
                facets: $facets
                typoTolerance: $typoTolerance
                advancedSyntax: $advancedSyntax
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
export enum SEARCH_STYLE_TYPE {
    algolia_styles = 'algolia_styles',
    algolia_styles_recommend = 'algolia_styles_recommend',
    algolia_stylist_styles = 'algolia_stylist_styles',
    algolia_styles_personalized = 'algolia_styles_personalized',
    algolia_styles_discover_styles = 'algolia_styles_discover_styles',
    algolia_style_it_right = 'algolia_style_it_right',
}
